import { render, staticRenderFns } from "./cardbind.vue?vue&type=template&id=ca046f9e&scoped=true&"
import script from "./cardbind.vue?vue&type=script&lang=js&"
export * from "./cardbind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca046f9e",
  null
  
)

export default component.exports